<template lang="pug">
    .card-display
        .thumb.pull-left(
            :style="({'background-image': `url(${data.content.title == 'Upcoming events' ? '/mnt/images/thumbs/rs5034_deptconted_creative_writing_by_john_cairns_7th_july_2014-71_thumb.jpg' : data.content.image})`})"
            
        )
            img(src="/static/images/1x1.gif" class="full-width")
        .card-margin
            a(:href="`/${data.content.title == 'Upcoming events' ? 'events/list/upcoming' : data.content.url}`" target="_blank")
                h4 {{ data.content.title }}
            p(v-html="data.content.snippet")

</template>


<script>
    export default {
        name: 'card',
        props: ['data']
    }
</script>



// WEBPACK FOOTER //
// src/components/RightCardDisplay.vue